import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import sleep from 'sleep-promise'
import useSessionFilters from '../hooks/useSessionFilters'
import ReactTooltip from 'react-tooltip';

const NotificationBadge = ({ count }) => (
  <div
    style={{
      position: 'absolute',
      top: '-10px',
      right: '-10px',
      backgroundColor: 'red',
      color: 'white',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      textAlign: 'center',
      lineHeight: '20px',
    }}
  >
    {count}
  </div>
);

const CustomTab = (props) => {
  const { getSavedFilters, updateSessionFilters } = useSessionFilters();

  const defaultParams = {
    defaultActiveTab: 0
  }
  const [params, setParams] = useState({ ...defaultParams, props });
  const [activeTab, setActiveTab] = useState('');
  let defaultNotifications = props.tab.map((tabs) => tabs.notificationsNumber ? tabs.notificationsNumber : 0)
  const dispatch = useDispatch()
  const resetSelector = useSelector((state) => state.core.session["custom_list_filter_reset"]);

  function updateDefaultActiveTab(selectedTabFilters) {
    setActiveTab(params.defaultActiveTab);
    selectedTabFilters = props.tab[params.defaultActiveTab]?.filters;
    props.setTabValues(selectedTabFilters);
  }

  useEffect(() => {
    let selectedTabFilters = props.tab[params.defaultActiveTab]?.filters;
    if (props.shouldLoadSavedState) {
      const savedTab = getSavedFilters().current_tab;
      if (savedTab) {
        setActiveTab(savedTab);
        selectedTabFilters = props.tab[savedTab]?.filters;
        props.setTabValues(selectedTabFilters);
      } else {
        updateDefaultActiveTab(selectedTabFilters);
      }
    } else {
      updateDefaultActiveTab(selectedTabFilters)
    }
    dispatch({ type: 'UPDATE_SESSION', key: 'current_tab_filter_notifications', value: defaultNotifications });

    setTimeout(() => {
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_tab_values', value: selectedTabFilters });
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    }, 1);

    return () => {
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_tab_values', value: {} });
    }

  }, [resetSelector])

  useEffect(() => { 
    if (!props.reloadCustomTab) return;
    
    handleTabChange(0);
  }, [props.tab]);

  const session = useSelector((state) => { return state.core.session['current_tab_filter_notifications'] });

  const handleTabChange = async (index) => {
    const currentFilters = getSavedFilters();
    const selectedTabFilters = props.tab[index].filters;
    const newFilters = {...currentFilters.filters, ...selectedTabFilters};
    setActiveTab(index);
    props.setTabValues(selectedTabFilters);
    if (props.shouldLoadSavedState) {
      updateSessionFilters({
        current_tab: index,
        filters: newFilters
      })
    }
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_tab_values', value: selectedTabFilters });
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    await sleep(700);
  };
  const CURRENT_URL_PATH = window.location.pathname;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
      <Nav
        style={{ marginLeft: props.tabType && props.tabType === 'pills' ? '10px' : '0px' }}
        tabs={!props.tabType || props.tabType === 'tabs'}
        pills={props.tabType && props.tabType === 'pills'}
      >
        {props.tab.map((tab, index) => (
          <NavItem key={index}>
            <NavLink
              style={{ cursor: 'pointer', position: 'relative', marginRight: '10px' }}
              className={classnames({ active: activeTab === index })}
              onClick={() => handleTabChange(index)}
            >
              {tab.label}
              {session?.list === CURRENT_URL_PATH && session?.value && session?.value[index] > 0 && (
                <NotificationBadge count={session?.value[index]} />
              )}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      {props.button && (
        <div>
          <button 
            disabled={props.button?.disabled || props.button?.isLoading} 
            onClick={props.button.callback} 
            className={`${props.button.class} float-right mr-2`} 
            data-tip 
            data-for={`button-${props.button.name}`}
          >
            {props.button.icon && !props.button?.isLoading && (
              <i className={`${props.button.icon} mr-1`} />
            )}
            {props.button?.isLoading && (
                <span class="spinner-border spinner-border-sm mr-1" aria-hidden="true"></span>
            )}
            {props.button.label}
          </button>
          <ReactTooltip id={`button-${props.button.name}`} place="top" effect="solid">
            {props.button.tooltipLabel}
          </ReactTooltip>
        </div>
      )}
    </div>
  );
}

export default CustomTab;